<template>
  <div>
    <DatePicker v-if="hasDateFilter" v-model="timespan" :mode="mode" />
  </div>
</template>
<script setup lang="ts">
import { RangeDateSelector as DatePicker } from '@/complib';
import type { FilterOptions } from '@/components/components/advancedList/useAdvancedList';
import dayjs from '@/helpers/dayJs';

const props = defineProps({
  filterKey: {
    type: String,
    required: true,
  },
  filters: {
    type: Object as PropType<Record<string, any>>,
    required: true,
    default: () => ({}) as Record<string, any>,
  },
  filterOptions: {
    type: Object as PropType<FilterOptions>,
    required: true,
    default: () => ({}) as FilterOptions,
  },
  mode: {
    type: String as PropType<'all' | 'future' | 'past'>,
    default: 'future',
  },
});
const emits = defineEmits<{
  (e: 'changeFilter', key: string, value: any): void;
}>();

const hasDateFilter = computed(() => props.filterOptions[props.filterKey]);
const timespan = ref<[Date, Date]>(
  props.filters[props.filterKey] ??
    (props.mode === 'future'
      ? [dayjs().toDate(), null]
      : [null, dayjs().toDate()]),
);

watch(timespan.value, (newValue) =>
  emits('changeFilter', props.filterKey, newValue),
);

watch(
  () => props.filters[props.filterKey],
  () => {
    if (
      props.filters[props.filterKey] &&
      timespan.value[0] !== props.filters[props.filterKey][0]
    ) {
      timespan.value[0] = props.filters[props.filterKey][0];
    }

    if (
      props.filters[props.filterKey] &&
      timespan.value[1] !== props.filters[props.filterKey][1]
    ) {
      timespan.value[1] = props.filters[props.filterKey][1];
    }
  },
);
</script>
